import { TableBody, TableRow } from '@material-ui/core';
import MyTableCell from './styled-components/MyTableCell';

const styles = {
	noReport: {
		minWidth: '100vw',
		minHeight: '160px',
		fontSize: '24px',
		fontWeight: '400',
		lineHeight: '24px'
	}
};

function NoReports() {
	return (
		<TableBody>
			<TableRow>
				<MyTableCell colSpan={5} />
			</TableRow>
			<TableRow>
				<MyTableCell colSpan={5} />
			</TableRow>
			<TableRow>
				<MyTableCell align="center" colSpan={6} style={styles.noReport}>
					No reports to show
				</MyTableCell>
			</TableRow>
			<TableRow />
		</TableBody>
	);
}

export default NoReports;
